module.exports = __webpack_public_path__ + "img/logo_bw.88259b17.png";